import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["target", "template"]

  add(e) {
    e.preventDefault()
    // Mengambil konten dari <template>
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    // Menyisipkannya ke dalam target div
    this.targetTarget.insertAdjacentHTML('beforeend', content)
  }

  remove(e) {
    e.preventDefault()
    const wrapper = e.target.closest(".nested-form-wrapper")
    
    // Jika data sudah ada di database, set _destroy = 1 (hidden field)
    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove()
    } else {
      wrapper.style.display = "none"
      wrapper.querySelector("input[name*='_destroy']").value = 1
    }
  }
}